import React from 'react';
import PropTypes from 'prop-types';

import './imagepreview.css';
interface Props {
  dataUri: string;
  isFullscreen: boolean;
}
function ImagePreview({ dataUri, isFullscreen }: Props) {
  const classNameFullscreen = isFullscreen
    ? 'demo-image-preview-fullscreen'
    : '';
  return (
    <div className={'demo-image-preview ' + classNameFullscreen}>
      <img src={dataUri} alt={'img'} />
    </div>
  );
}
ImagePreview.propTypes = {
  dataUri: PropTypes.string,
  isFullscreen: PropTypes.bool,
};
export default ImagePreview;
